import React from "react";

const AboutUs = () => (
  <div className="legal-page-container">
    <h1>About Us</h1>
    <div className="legal-content">
      <p>
        <strong>Contest Hub</strong> is a calm, focused space for competitive
        programmers. Our mission is to help you stay consistent, track your
        progress, and compete with clarity—without distractions or noise.
      </p>
      <p>
        Built by{" "}
        <a
          href="https://labs.champ96k.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Champ96k Labs
        </a>
        , we believe in privacy-first, ad-free experiences for the coding
        community. We aggregate contests, provide gentle reminders, and help you
        visualize your coding journey.
      </p>
      <p>
        <strong>Contact us:</strong> For feedback, support, or partnership
        inquiries, email{" "}
        <a href="mailto:champ96klabs@gmail.com">champ96klabs@gmail.com</a>.
      </p>
      <p>
        <strong>Learn more:</strong>{" "}
        <a
          href="https://labs.champ96k.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          labs.champ96k.com
        </a>
      </p>
    </div>
  </div>
);

export default AboutUs;
